// extracted by mini-css-extract-plugin
module.exports = {"dataRow":"DataRow_dataRow_1xiow","noBorder":"DataRow_noBorder_2Hmmm"};